/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, {Component} from 'react';
import  UploadWall from '../../../components/upload/UploadWall'
import ChunkUpload from '../../../components/upload/ChunkUpload';
import {FILE_TYPE, PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE} from '../../../constants';
import { Modal,message} from 'antd';
import PropTypes from "prop-types";
import {exist} from '../../../actions/allResources'
import {FileCountLimiter} from "../../../components/upload/FileCountLimiter";
import {applicationName} from "../../../utils";

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default class UpLoad extends Component {
    // 默认属性
    static defaultProps = {
        fileList:[],
        type:1,
        updateFileList:()=>{},
        imgHandleChange:()=>{

        },
    };
    // 静态类型分析
    static propTypes = {
        fileList:PropTypes.array.isRequired,//选择文件的数组
        imgHandleChange:PropTypes.func.isRequired,//选择图片
        type:PropTypes.number.isRequired,//选择文件上传文件类型
    };
    constructor(props) {
        super(props);
        this.state = {
            previewVisible:false,
            type:'',
            Collection:true,
        };

    }

    // //预览
    // handlePreview = async file => {
    //     if (file.fileType === 3){//代表是视频
    //         file.url = file.path
    //     }else{
    //         if (!file.url && !file.preview) {
    //             file.preview = await getBase64(file.originFileObj);
    //         }
    //     }
    //     console.log("url:    ", file.url || file.preview);
    //     this.setState({
    //         previewImage: file.url || file.preview,
    //         previewVisible: true,
    //         fileType: file.fileType
    //     });
    // };


    handlePreview = async file => {


        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }else{
            file.url = file.path
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,

        });
    };
    handleOk=()=>{

    };
    fileExit(res){
         if(res.storageFile.type === 1){
             this.setState({type:2})
         }else if(res.storageFile.type === 2){
             this.setState({type:3})
         }else if(res.storageFile.type === 3){
             this.setState({type:4})
         }else if(res.storageFile.type === 4){
             this.setState({type:5})
         }

        exist(res.url, this.state.type, (data) => {
            res.exist=true;//该图片已经上传过

        });
    }

    limiter = (()=>{
        let uploadSyncMaxCount = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("upload.sync.max.count", "5");//默认5个并发
        console.log("uploadSyncMaxCount:   " + uploadSyncMaxCount);
        return new FileCountLimiter(parseInt(uploadSyncMaxCount));
    })();

    render() {
        let accept;
        console.log(this.props.type);
        switch (this.props.type) {
            case 1:
                accept = "." + [...PIC_TYPE,].join(",.");
                break;
            case 2:
                accept = "." + [...AUDIO_TYPE].join(",.");
                break;
            case 3:
                accept = "." + [...VIDEO_TYPE].join(",.");
                break;
            case 4:
                accept = "." + [...FILE_TYPE].join(",.");
                break;
            case 0:
                accept = "." + [...FILE_TYPE].join(",.");
                break;
        }


        return (

            <div>
                <UploadWall
                    accept={accept}
                    multiple={true}
                    action={"/cm-sites-" + applicationName() + "/index/uploadFile"}
                    listType="picture-card"
                    fileList={this.props.fileList}
                    beforeUpload={(file, fileList) => {
                        console.log(file, fileList)
                       let fileName = file.type.split('/')[1];
                        console.log(fileName)
                       if(fileName==='quicktime'){
                           fileName = 'mov'
                       }
                       if(accept.indexOf(fileName) === -1){
                           let newType='';
                           let nameList=file.name.split('.');
                           newType=nameList.length>0?nameList[nameList.length-1]:'';
                           if(accept.indexOf(newType) === -1) {
                               message.warn('只支持' + accept + '格式');
                               return false
                           }else{
                               console.log(fileList)
                               let newFileList = fileList;
                               newFileList.forEach((item, index) => {
                                   let itemFileName = file.type.split('/')[1];
                                   if (accept.indexOf(itemFileName) === -1) {
                                       newFileList.splice(item, 1)
                                   }
                               });
                           }
                          // this.props.updateFileList(newFileList);

                       }

                    }}

                    customRequest={new ChunkUpload({
                        checkFileURL: "/cm-sites-" + applicationName() + "/index/checkFile",
                        checkChunkURL: "/cm-sites-" + applicationName() + "/index/checkChunk",
                        uploadChunkURL: "/cm-sites-" + applicationName() + "/index/uploadChunks",
                        chunkUploadOverURL: "/cm-sites-" + applicationName() + "/index/chunkUploadOver",
                        mergeChunksURL: "/cm-sites-" + applicationName() + "/index/mergeChunks",
                        limiter:this.limiter,
                        fileExitCallFunction:(res)=>{
                            this.fileExit(res)
                        },
                        fileError:(md5)=>{
                            console.log('errorFile--------------',md5);
                            this.props.fileError&&this.props.fileError(md5);
                        }
                    }).start}
                    icons={(() => {
                        let res = ["eye", "play", "download"];
                        return res;
                    })()}
                    reUpload={(uid)=>{
                        this.limiter.retry(uid).then(()=>{
                            message.success("已成功加入到上传队列中，请稍后");
                        }).catch(()=>{
                            message.error("未获取到该文件，等待所有文件上传完成后，再关闭页面，重新选择上传");
                        });
                    }}
                    onChange={this.props.imgHandleChange}
                    onPreview={this.handlePreview}
                    uploadBtnName={""}
                    onPlay={this.handlePreview}
                    showUploadBtn={true}
                    onDownload={(file) => {
                        if (file.path.indexOf("?") === -1) {
                            window.location.href = file.path + "?download=1";
                        } else {
                            window.location.href = file.path + "&download=1";
                        }
                    }}
                    style={{padding: "0px"}}
                >
                </UploadWall>
                <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}>
                    <div>

                        {
                            this.props.type === 1 ? <img alt="example" style={{ width: '100%' }} src={this.state.previewImage} /> : <video controls={"controls"} style={{ width: '100%' }} src={this.state.previewImage} />
                        }
                    </div>
                </Modal>

            </div>



        );
    }

}
